<template>
    <section>
        <ds-modal
            :is-open="isOpen"
            center
        >
            <div class="popover-contents">
                {{ $options.ERROR_MSG }}
            </div>
            <div>
                <a href="/Reports/searchTemplate.jsp?reportClass=SetupLeadSource&amp;view=resultsPage&amp;returnTo=/app/miscSetting/showSection?systemId=nav.marketing&amp;settingModuleName=Marketing&amp;settingTabName=leadSource.plural">Manage
                    Lead Sources</a>
                <ds-button class="lead-button" @click="addLeadSource">
                    OK
                </ds-button>
            </div>
        </ds-modal>
    </section>
</template>

<script>
export const ERROR_MSG = 'You have reached a reporting limit for lead sources. This means that some of your lead sources will not show in the lead source report (current limit is 50K lead sources). If you would like all of your sources displayed, please delete any unwanted lead sources until you are under 50K sources.';

export default {
    ERROR_MSG,

    name: 'LeadGenerationWarningModal',

    data() {
        return {
            isOpen: false,
        };
    },

    methods: {
        showModal() {
            this.isOpen = true;
        },

        addLeadSource() {
            this.$root.$emit('ADD_LEAD_SOURCE', true);
        },
    },
};
</script>

<style lang="scss" scoped>
.popover-contents {
    justify-content: space-between;
    margin-top: $spacing-100;
    margin-bottom: $spacing-300;
    font-size: 1.2rem;
}

.lead-button {
    float: right;
}
</style>
